var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C10.1333 23 8.41667 22.575 6.85 21.725C5.28333 20.875 4 19.7417 3 18.325V21H1V15H7V17H4.525C5.325 18.2 6.37917 19.1667 7.6875 19.9C8.99583 20.6333 10.4333 21 12 21C13.25 21 14.4208 20.7625 15.5125 20.2875C16.6042 19.8125 17.5542 19.1708 18.3625 18.3625C19.1708 17.5542 19.8125 16.6042 20.2875 15.5125C20.7625 14.4208 21 13.25 21 12H23C23 13.5167 22.7125 14.9417 22.1375 16.275C21.5625 17.6083 20.775 18.775 19.775 19.775C18.775 20.775 17.6083 21.5625 16.275 22.1375C14.9417 22.7125 13.5167 23 12 23ZM11.1 19V17.7C10.3167 17.5167 9.67917 17.1792 9.1875 16.6875C8.69583 16.1958 8.33333 15.55 8.1 14.75L9.75 14.1C9.95 14.7833 10.2625 15.2958 10.6875 15.6375C11.1125 15.9792 11.6 16.15 12.15 16.15C12.7 16.15 13.1708 16.0208 13.5625 15.7625C13.9542 15.5042 14.15 15.1 14.15 14.55C14.15 14.0667 13.9458 13.675 13.5375 13.375C13.1292 13.075 12.4 12.7333 11.35 12.35C10.3667 12 9.64583 11.5833 9.1875 11.1C8.72917 10.6167 8.5 9.98333 8.5 9.2C8.5 8.51667 8.7375 7.89583 9.2125 7.3375C9.6875 6.77917 10.3333 6.41667 11.15 6.25V5H12.9V6.25C13.5 6.3 14.0458 6.54167 14.5375 6.975C15.0292 7.40833 15.3667 7.91667 15.55 8.5L13.95 9.15C13.8167 8.76667 13.6 8.44583 13.3 8.1875C13 7.92917 12.5833 7.8 12.05 7.8C11.4667 7.8 11.0208 7.925 10.7125 8.175C10.4042 8.425 10.25 8.76667 10.25 9.2C10.25 9.63333 10.4417 9.975 10.825 10.225C11.2083 10.475 11.9 10.7667 12.9 11.1C14.1 11.5333 14.9 12.0417 15.3 12.625C15.7 13.2083 15.9 13.85 15.9 14.55C15.9 15.0333 15.8167 15.4583 15.65 15.825C15.4833 16.1917 15.2625 16.5042 14.9875 16.7625C14.7125 17.0208 14.3917 17.2292 14.025 17.3875C13.6583 17.5458 13.2667 17.6667 12.85 17.75V19H11.1ZM1 12C1 10.4833 1.2875 9.05833 1.8625 7.725C2.4375 6.39167 3.225 5.225 4.225 4.225C5.225 3.225 6.39167 2.4375 7.725 1.8625C9.05833 1.2875 10.4833 1 12 1C13.8667 1 15.5833 1.425 17.15 2.275C18.7167 3.125 20 4.25833 21 5.675V3H23V9H17V7H19.475C18.675 5.8 17.6208 4.83333 16.3125 4.1C15.0042 3.36667 13.5667 3 12 3C10.75 3 9.57917 3.2375 8.4875 3.7125C7.39583 4.1875 6.44583 4.82917 5.6375 5.6375C4.82917 6.44583 4.1875 7.39583 3.7125 8.4875C3.2375 9.57917 3 10.75 3 12H1Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvesting);
export default __webpack_public_path__ + "static/media/Investing.eeb0231f.svg";
export { ForwardRef as ReactComponent };